/**
 * Collapsible sections
 *
 * @package EBNewsletters
 */

const COLLAPSE = {
	toggle: '[data-collapse-toggle]',
	until: '--collapse-until',
	open: 'is-open',
	animating: 'is-animating',
};

const setOpen = (button, collapse, open) => {
	button.setAttribute('aria-expanded', String(open));
	collapse.classList.toggle(COLLAPSE.open, open);
};

const init = button => {
	const collapse = document.getElementById(
		button.getAttribute('aria-controls')
	);
	if (!collapse) {
		return;
	}

	collapse.addEventListener('transitionend', event => {
		if (event.target === collapse) {
			collapse.classList.remove(COLLAPSE.animating);
		}
	});

	button.addEventListener('click', () => {
		collapse.classList.add(COLLAPSE.animating);
		setOpen(button, collapse, button.getAttribute('aria-expanded') !== 'true');
	});

	const until = getComputedStyle(collapse).getPropertyValue(COLLAPSE.until);
	if (!until) {
		return;
	}

	const wide = window.matchMedia(`(min-width: ${until})`);

	const sync = () => {
		collapse.classList.remove(COLLAPSE.open, COLLAPSE.animating);
		button.tabIndex = wide.matches ? -1 : 0;
		if (wide.matches) {
			button.removeAttribute('aria-expanded');
		} else {
			button.setAttribute('aria-expanded', 'false');
		}
	};

	sync();
	wide.addEventListener('change', sync);
};

const initCollapsibles = () =>
	document.querySelectorAll(COLLAPSE.toggle).forEach(init);

export default initCollapsibles;
